import Koppa from "@koppajs/koppajs-core";

// modules
import scriptController from "./modules/script-controller";
Koppa.take(scriptController);

import consentManager from "./modules/consent-manager";
Koppa.take(consentManager);

import router from "./modules/router";
Koppa.take(router);

import dialog from "./modules/dialog";
Koppa.take(dialog);

// import koppaForms from "./modules/koppaForms";
// Koppa.take(koppaForms);

// styles
import "./assets/styles/fonts.css";
// import "./assets/styles/font-awesome-6.5.1.all.min.css"
import "./assets/styles/normalize.css";
import "./assets/styles/main.css";

import app from './components/app.kpa';
Koppa.take(app, 'k-app');

// layout
import topBar from './components/layout/top-bar.kpa';
Koppa.take(topBar, 'top-bar');

import appBar from './components/layout/app-bar.kpa';
Koppa.take(appBar, 'app-bar');

import toolBar from './components/layout/tool-bar.kpa';
Koppa.take(toolBar, 'tool-bar');

import dynamicBreadcrumbs from './components/layout/dynamic-breadcrumbs.kpa';
Koppa.take(dynamicBreadcrumbs, 'dynamic-breadcrumbs');

import socialSidebar from './components/layout/social-sidebar.kpa';
Koppa.take(socialSidebar, 'social-sidebar');

import heroSection from './components/layout/hero-section.kpa';
Koppa.take(heroSection, 'hero-section');

import heroGruenpflege from './components/layout/hero-gruenpflege.kpa';
Koppa.take(heroGruenpflege, 'hero-gruenpflege');

import heroHome from './components/layout/hero-home.kpa';
Koppa.take(heroHome, 'hero-home');

import footerSection from './components/layout/footer-section.kpa';
Koppa.take(footerSection, 'footer-section');

import hexButton from './components/layout/hex-button.kpa';
Koppa.take(hexButton, 'hex-button');

import hexHeadline from './components/layout/hex-headline.kpa';
Koppa.take(hexHeadline, 'hex-headline');

import hexText from './components/layout/hex-text.kpa';
Koppa.take(hexText, 'hex-text');

// shared
import contactForm from './components/shared/contact-form.kpa';
Koppa.take(contactForm, 'contact-form');

import openMap from './components/shared/open-map.kpa';
Koppa.take(openMap, 'open-map');

import gMaps from './components/shared/g-maps.kpa';
Koppa.take(gMaps, 'g-maps');

import gReviews from './components/shared/g-reviews.kpa';
Koppa.take(gReviews, 'g-reviews');

import ctaSection from './components/shared/cta-section.kpa';
Koppa.take(ctaSection, 'cta-section');

// home
import benefitsSection from './components/pages/home/benefits-section.kpa';
Koppa.take(benefitsSection, 'benefits-section');

import welcomeSection from './components/pages/home/welcome-section.kpa';
Koppa.take(welcomeSection, 'welcome-section');

import testimonialsSection from './components/pages/home/testimonials-section.kpa';
Koppa.take(testimonialsSection, 'testimonials-section');

import servicesSection from './components/pages/home/services-section.kpa';
Koppa.take(servicesSection, 'services-section');

// ueberuns
import memberCard from './components/pages/ueberuns/fachkompetenz/member-card.kpa';
Koppa.take(memberCard, 'member-card');

import modalHsidar from './components/pages/ueberuns/fachkompetenz/modal-hsidar.kpa';
Koppa.take(modalHsidar, 'modal-hsidar');

import modalSlaudani from './components/pages/ueberuns/fachkompetenz/modal-slaudani.kpa';
Koppa.take(modalSlaudani, 'modal-slaudani');

export default (async () => {
  new Koppa();
})();